<template>
  <div>
    <!-- 公共部分 -->
    <div
      class="verify-bar-area"
      :style="{ width: setSize.barWidth, height: barSize.height, 'line-height': barSize.height, color: barColor }"
    >
      <!-- refactor -->
      <span class="verify-msg" :style="{ paddingLeft: '38px',fontSize: '13px' ,color: '#5CB85C' }" v-text="text"></span>
      <div
        class="verify-left-bar"
        :style="{
          width: leftBarWidth !== undefined ? leftBarWidth : barSize.height,
          height: barSize.height,
          'border-color': leftBarBorderColor,
          transaction: transitionWidth,
        }"
      >
        <span class="verify-msg" v-text="finishText"></span>
        <div
          class="verify-move-block"
          @touchstart="start"
          @mousedown="start"
          :style="{
            width: barSize.height,
            height: barSize.height,
            'background-color': moveBlockBackgroundColor,
            left: moveBlockLeft,
            transition: transitionLeft,
          }"
        >
          <i :class="['verify-icon iconfont', iconClass]" :style="{ color: iconColor }"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
/**
 * VerifySlide
 * @description 滑块
 * */

export default {
  name: 'VerifySlide',
  props: {
    type: {
      type: String,
      default: '1',
    },
    // 弹出式pop，固定fixed
    mode: {
      type: String,
      default: 'fixed',
    },
    vOffset: {
      type: Number,
      default: 5,
    },
    vSpace: {
      type: Number,
      default: 5,
    },
    explain: {
      type: String,
      default: '',
    },
    finishingText: {
      type: String,
      default: '',
    },
    imgSize: {
      type: Object,
      default() {
        return {
          width: '400px',
          height: '200px',
        };
      },
    },
    blockSize: {
      type: Object,
      default() {
        return {
          width: '50px',
          height: '50px',
        };
      },
    },
    barSize: {
      type: Object,
      default() {
        return {
          width: '400px',
          height: '40px',
        };
      },
    },
    barMargin: {
      type: String,
      default: 'auto',
    },
    startMoveBlockBackgroundColor: {
      type: String,
      default: '#337ab7',
    },
  },
  data() {
    return {
      imgRand: 0,
      text: '',
      finishText: '',
      setSize: {
        imgHeight: 0,
        imgWidth: 0,
        barHeight: 0,
        barWidth: 0,
      },
      top: 0,
      left: 0,
      showImage: true,
      moveBlockLeft: undefined,
      leftBarWidth: undefined,
      // 移动中样式
      barColor: '#fff',
      moveBlockBackgroundColor: undefined,
      leftBarBorderColor: '#ddd',
      iconColor: undefined,
      iconClass: 'icon-right',
      status: false, // 鼠标状态
      isEnd: false, // 是够验证完成
      transitionLeft: '',
      transitionWidth: '',
    };
  },
  computed: {
    barArea() {
      return this.$el.querySelector('.verify-bar-area');
    },
    resetSize() {
      let img_width, img_height, bar_width, bar_height; // 图片的宽度、高度，移动条的宽度、高度

      let parentWidth = this.$el.parentNode.offsetWidth || window.offsetWidth;
      let parentHeight = this.$el.parentNode.offsetHeight || window.offsetHeight;

      if (this.imgSize.width.indexOf('%') !== -1) {
        img_width = (parseInt(this.imgSize.width) / 100) * parentWidth + 'px';
      } else {
        img_width = this.imgSize.width;
      }

      if (this.imgSize.height.indexOf('%') !== -1) {
        img_height = (parseInt(this.imgSize.height) / 100) * parentHeight + 'px';
      } else {
        img_height = this.imgSize.height;
      }

      if (this.barSize.width.indexOf('%') !== -1) {
        bar_width = (parseInt(this.barSize.width) / 100) * parentWidth + 'px';
      } else {
        bar_width = this.barSize.width;
      }

      if (this.barSize.height.indexOf('%') !== -1) {
        bar_height = (parseInt(this.barSize.height) / 100) * parentHeight + 'px';
      } else {
        bar_height = this.barSize.height;
      }

      return { imgWidth: img_width, imgHeight: img_height, barWidth: bar_width, barHeight: bar_height };
    },
  },
  watch: {
    explain: {
      immediate: true,
      handler(val) {
        this.text = val;
      },
    },
    _finishText: {
      immediate: true,
      handler(newVal, oldVal) {
        if (this.finishText) {
          this.finishText = newVal;
        }
      },
    },
    // type变化则全面刷新
    type: {
      immediate: true,
      handler() {
        this.init();
      },
    },
  },
  mounted() {
    // 禁止拖拽
    this.$el.onselectstart = function() {
      return false;
    };
  },
  methods: {
    init() {
      this.text = this.explain;

      this.$nextTick(() => {
        let setSize = this.resetSize; // 重新设置宽度高度
        // 监听的问题
        for (let key in setSize) {
          this.$set(this.setSize, key, setSize[key]);
        }
        this.$parent.$emit('ready', this);
      });

      let _this = this;

      window.removeEventListener('touchmove', function(e) {
        _this.move(e);
      });
      window.removeEventListener('mousemove', function(e) {
        _this.move(e);
      });

      // 鼠标松开
      window.removeEventListener('touchend', function() {
        _this.end();
      });
      window.removeEventListener('mouseup', function() {
        _this.end();
      });

      window.addEventListener('touchmove', function(e) {
        _this.move(e);
      });
      window.addEventListener('mousemove', function(e) {
        _this.move(e);
      });

      // 鼠标松开
      window.addEventListener('touchend', function() {
        _this.end();
      });
      window.addEventListener('mouseup', function() {
        _this.end();
      });
    },

    // 鼠标按下
    start: function(e) {
      if (this.isEnd === false) {
        this.text = '';
        this.moveBlockBackgroundColor = '#337ab7';
        this.leftBarBorderColor = '#337AB7';
        this.iconColor = '#fff';
        e.stopPropagation();
        this.status = true;
      }
    },
    // 鼠标移动
    move: function(e) {
      let x;
      if (this.status && this.isEnd === false) {
        if (!e.touches) {
          // 兼容移动端
          x = e.clientX;
        } else {
          // 兼容PC端
          x = e.touches[0].pageX;
        }
        let bar_area_left = this.getLeft(this.barArea);
        let move_block_left = x - bar_area_left; // 小方块相对于父元素的left值
        // 普通滑动
        if (move_block_left >= this.barArea.offsetWidth - parseInt(parseInt(this.barSize.height) / 2) + 3) {
          // this.finishText = "松开验证";
          move_block_left = this.barArea.offsetWidth - parseInt(parseInt(this.barSize.height) / 2) + 3;
        } else {
          this.finishText = '';
        }

        if (move_block_left <= parseInt(parseInt(this.blockSize.width) / 2)) {
          move_block_left = parseInt(parseInt(this.blockSize.width) / 2);
        }
        // 拖动后小方块的left值
        this.moveBlockLeft = move_block_left - parseInt(parseInt(this.blockSize.width) / 2) + 'px';
        this.leftBarWidth = move_block_left - parseInt(parseInt(this.blockSize.width) / 2) + 'px';
      }
    },

    // 鼠标松开
    end: function() {
      let _this = this;
      //                判断是否重合
      if (this.status && this.isEnd === false) {
        // 普通滑动

        if (
          parseInt((this.moveBlockLeft || '').replace('px', '')) >=
          parseInt(this.setSize.barWidth) - parseInt(this.barSize.height) - parseInt(this.vOffset)
        ) {
          this.moveBlockBackgroundColor = '#5cb85c';
          //                            this.htmlDoms.left_bar.css({
          //                                'color': '#4cae4c',
          //                                'border-color': '#5cb85c',
          //                                'background-color': '#fff'
          //                            });
          this.leftBarBorderColor = '#5cb85c';
          this.iconColor = '#fff';
          this.iconClass = 'icon-check';
          this.showRefresh = false;
          this.barColor = '#5cb85c';
          this.finishText = this._finishText;
          this.isEnd = true;
          this.$parent.$emit('success', this);
        } else {
          this.finishText = '';
          this.moveBlockBackgroundColor = '#d9534f';
          this.leftBarBorderColor = '#d9534f';
          this.iconColor = '#fff';
          this.iconClass = 'icon-close';
          this.isEnd = true;

          setTimeout(function() {
            _this.finishText = '';
            _this.refresh();
            _this.isEnd = false;
          }, 400);

          this.$parent.$emit('error', this);
        }

        this.status = false;
      }
    },

    refresh: function() {
      this.showRefresh = true;
      this.finishText = '';

      this.transitionLeft = 'left .3s';
      this.moveBlockLeft = 0;

      this.leftBarWidth = undefined;
      this.transitionWidth = 'width .3s';

      this.leftBarBorderColor = '#ddd';
      this.moveBlockBackgroundColor = '#fff';
      this.iconColor = '#000';
      this.iconClass = 'icon-right';

      this.isEnd = false;

      setTimeout(() => {
        this.transitionWidth = '';
        this.transitionLeft = '';
        this.text = this.explain;
      }, 300);
    },

    // 获取left值
    getLeft: function(node) {
      let leftValue = 0;
      while (node) {
        leftValue += node.offsetLeft;
        node = node.offsetParent;
      }
      let finalvalue = leftValue;
      return finalvalue;
    },
  },
  i18n: {
    messages: {
      'en-US': {},
      'zh-CN': {},
    },
  },
};
</script>
